import React, { Component } from 'react';

import { Route, Switch } from 'react-router-dom';

import Home from "./Home";
import Login from "./Login";

import auth0 from 'auth0-js';

const auth = new auth0.WebAuth({
    domain: 'rmsmedpro.auth0.com',
    clientID: '0u5E7YFAm7QYYRh793kuZ3Av4DACQB5v',
    redirectUri: window.location.origin + '/authentication',
    // redirectUri: 'https://rmscalculator.com/authentication',
    // redirectUri: 'https://d1muuojj8xvjxe.cloudfront.net/authentication',
    // redirectUri: 'http://rms-calculator-v2.s3-website-us-east-1.amazonaws.com/authentication',
    // redirectUri: 'http://localhost:3000/authentication',
    // audience: 'https://rmsmedpro.auth0.com/userinfo',
    audience: 'https://rmsmedpro.auth0.com/api/v2/',
    responseType: 'token id_token',
    scope: 'openid profile roles user_id name email update:users update:users_app_metadata update:current_user_metadata read:user_idp_tokens read:users read:current_user'
});

// const handleAuthentication = () => {
//     auth.parseHash((err, authResult) => {
//       if (authResult && authResult.accessToken && authResult.idToken) {
//         this.setState({sessionToken: authResult});
//         Router.history.replace('/');
//       } else if (err) {
//         console.log(err);
//       }
//     });
//   };

// const home = () =>(
//       <div>
//           <Home></Home>
//       </div>
// );

// const login = () =>(
//       <div>
//           <Login></Login>
//       </div>
// );

class App extends Component {

  handleAuthentication = () => {
    auth.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
        localStorage.setItem('access_token', authResult.accessToken);
        localStorage.setItem('id_token', authResult.idToken);
        localStorage.setItem('authResult', JSON.stringify(authResult));
        localStorage.setItem('expires_at', expiresAt);
        window.location.replace('/calculator');
      } else if (err) {
        console.log(err);
      }
    });
  };

  getUserData = (userId) => {
    let prom = new Promise((resolve, reject) => {
        var authResult = JSON.parse(localStorage.getItem('authResult'));
        var request = require('request');

        if(authResult) {
            var options = {
                method: 'GET',
                url: 'https://rmsmedpro.auth0.com/api/v2/users/' + userId,
                qs: {fields: 'user_metadata', include_fields: 'true'},
                headers:
                    {
                        'content-type': 'application/json',
                        authorization: 'Bearer ' + authResult.accessToken
                    }
            };

            request(options, function (error, response, body) {
                var userInfo = JSON.parse(body);
                if(userInfo && userInfo.user_metadata && userInfo.user_metadata.profileData){
                    resolve();
                }else{
                    reject();
                }
            });
        }
    });

    return prom;

  };


  updateUserData = (data) => {
    var request = require("request");
    var authResult = JSON.parse(localStorage.getItem('authResult'));

    if (authResult) {
          auth.client.userInfo(authResult.accessToken, (err, profile) => {
              if (profile) {
                 var options = { method: 'PATCH',
                  url: 'https://rmsmedpro.auth0.com/api/v2/users/' + profile.sub,
                  headers:
                   { 'content-type': 'application/json',
                     Authorization: 'Bearer ' + authResult.accessToken },
                     body: '{"user_metadata": {"profileData": ' + JSON.stringify(data) + ' }}' };

                    request(options, function (error, response, body) {

                    });
              }
          });
      }
  };

  validateUser = () => {
      let prom = new Promise((resolve, reject) => {
          var authResult = JSON.parse(localStorage.getItem('authResult'));

          if (authResult) {
              auth.client.userInfo(authResult.accessToken, (err, profile) => {
                  if (profile) {

                      //this.updateUserData(profile.sub);
                      this.getUserData(profile.sub).then(()=>{
                          resolve();
                      }, ()=>{
                         reject();
                      });
                  }else{
                      reject();
                  }

              });
          }
      });
      return prom;
  };

  validateToken = () => {
      let prom = new Promise((resolve, reject) => {
          var authResult = JSON.parse(localStorage.getItem('authResult'));

          if (authResult) {
              auth.client.userInfo(authResult.accessToken, (err, profile) => {
                  if (profile) {
                     resolve();
                  }else{
                      reject();
                  }
              });
          }else{
              reject();
          }

      });

      return prom;
  };

  render() {
    return (
      <div>
        <Switch>
            {/*<Route exact path="/" render={(props) => <Login {...props} auth={auth} validateToken = {() => this.validateToken()}/>} />*/}
            <Route exact path="/" render={(props) => <Home {...props} validateToken = {() => this.validateToken()} validateUser = {() => this.validateUser()} updateUserData={(data) => this.updateUserData(data)} />} />
            <Route exact path="/calculator" render={(props) => <Home {...props} validateToken = {() => this.validateToken()} validateUser = {() => this.validateUser()} updateUserData={(data) => this.updateUserData(data)} />} />
            <Route path="/authentication" render={(props) => {this.handleAuthentication(props); return <div/>}} />
            <Route path="*" render={(props) => <Login {...props} auth={auth} wrongUrl={true} validateToken = {() => this.validateToken()}/>} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js